/**
 * Kivo CRM: generate contact summary via backend (invoke_contact_summary_agent).
 * POST /api/v1/accounts/:accountId/contacts/:contactId/summary
 * Uses axios so the api_access_token header (set at login in axios defaults) is sent automatically.
 */
/* global axios */
export async function generateContactSummary(accountId, contactId) {
  const url = `/api/v1/accounts/${accountId}/contacts/${contactId}/summary`;
  const response = await axios.post(url);
  return response.data;
}
